module.exports = __webpack_public_path__ + "static/img/recommend-list-6.f8b8a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-6.png
// module id = ybwR
// module chunks = 1